import { createContext, useContext, useState, useEffect } from 'react';

const BionicReadingContext = createContext();

export const useBionicReading = () => {
  const context = useContext(BionicReadingContext);
  if (!context) {
    throw new Error('useBionicReading must be used within a BionicReadingProvider');
  }
  return context;
};

export const BionicReadingProvider = ({ children }) => {
  const [bionicEnabled, setBionicEnabled] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('bionicReading') === 'true';
    }
    return false;
  });

  useEffect(() => {
    localStorage.setItem('bionicReading', bionicEnabled.toString());
  }, [bionicEnabled]);

  const toggleBionic = () => {
    setBionicEnabled(prev => !prev);
  };

  const value = {
    bionicEnabled,
    setBionicEnabled,
    toggleBionic,
  };

  return (
    <BionicReadingContext.Provider value={value}>
      {children}
    </BionicReadingContext.Provider>
  );
};

// Utility function to convert text to bionic format
export const toBionicText = (text) => {
  if (!text) return '';
  
  return text.split(' ').map((word, index) => {
    if (word.length <= 1) return word;
    
    const boldLength = Math.ceil(word.length * 0.5);
    const boldPart = word.slice(0, boldLength);
    const normalPart = word.slice(boldLength);
    
    return (
      <span key={index}>
        <b>{boldPart}</b>{normalPart}{' '}
      </span>
    );
  });
};
